var _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21,
    r: 21,
    fill: "#EFFCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18.9229C14.5 23.7747 18.7445 27.7869 20.6232 29.3252C20.8921 29.5454 21.0281 29.6568 21.2287 29.7132C21.3849 29.7572 21.6148 29.7572 21.771 29.7132C21.972 29.6567 22.1071 29.5463 22.377 29.3254C24.2557 27.7871 28.4999 23.7751 28.4999 18.9233C28.4999 17.0872 27.7625 15.3261 26.4497 14.0277C25.137 12.7294 23.3566 12 21.5001 12C19.6436 12 17.863 12.7295 16.5503 14.0278C15.2375 15.3262 14.5 17.0867 14.5 18.9229Z",
    stroke: "#2DBBDA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 18,
    r: 2.5,
    stroke: "#2DBBDA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLocation);
export default __webpack_public_path__ + "static/media/dashboardLocation.76b089d615ccadf1db9b1f859a0afb66.svg";
export { ForwardRef as ReactComponent };